import ProfilIndex from "@/views/profil/ProfilForm.vue";

const profil = [
    {
        path: '/profil',
        name: 'profil',
        component: ProfilIndex,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office'], 
        },
    }
]

export default profil;